// auth.guard.ts
import {Injectable} from "@angular/core";
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild} from "@angular/router";
import {AuthService} from "./auth.service";
import {Router} from "@angular/router";
import {APIService} from "../api.service";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private authService: AuthService,
        private router: Router,
        private api: APIService
    ) {
    }

    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (this.authService.isLoggedIn) {
            try {
                await this.api.post("/moduloGeral/usuario/ping", {}, undefined, true);

                this.authService.isLoggedIn = true;
            } catch (error) {
                this.authService.isLoggedIn = false;
            }
        }

        return this.authService.isLoggedIn;
    }

    canActivateChild(next: ActivatedRouteSnapshot,
                     state: RouterStateSnapshot): Promise<boolean> | boolean {
        return this.canActivate(next, state);
    }
}
